import React, { useState, useEffect } from "react";
import "@/App.css";
import { Toaster } from "./components/ui/sonner";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

// Components
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Highlights from "./components/Highlights";
import Pricing from "./components/Pricing";
import FloorPlans from "./components/FloorPlans";
import Amenities from "./components/Amenities";
import Gallery from "./components/Gallery";
import Location from "./components/Location";
import {
  PopupForm,
  StickySidebarForm,
  StickySideForm,
  FooterContactForm,
  WhatsAppButton,
} from "./components/ContactForms";

import PrivacyPolicy from "./components/PrivacyPolicy";
import Disclaimer from "./components/Disclaimer";
import TermsAndConditions from "./components/Terms&Conditions";
import ThankYou from "./components/ThankYou";

function App() {
  const [showPopup, setShowPopup] = useState(false);
  const [showEnquiryForm, setShowEnquiryForm] = useState(false);

  // Show popup after 5 seconds
  useEffect(() => {
    const timer = setTimeout(() => {
      const hasInteracted = sessionStorage.getItem("enquiryInteracted");
      if (!hasInteracted) {
        setShowPopup(true);
      }
    }, 5000);

    return () => clearTimeout(timer);
  }, []);

  const handleEnquireClick = () => {
    sessionStorage.setItem("enquiryInteracted", "true");
    setShowEnquiryForm(true);
  };

  const handleBrochureClick = () => {
    window.open(
      "https://customer-assets.emergentagent.com/job_luxury-homes-hub-15/artifacts/mxy8ju30_Suncity%20Brochure%2011x11%20in.pdf",
      "_blank"
    );
  };

  const handlePopupClose = () => {
    sessionStorage.setItem("enquiryInteracted", "true");
    setShowPopup(false);
  };

  return (
  <Router>
    <div className="App bg-white min-h-screen" data-testid="app-container">
      {/* Toaster */}
      <Toaster position="top-right" richColors />

      <Routes>
        {/* MAIN LANDING PAGE */}
        <Route
          path="/"
          element={
            <>
              {/* Navigation */}
              <Navbar onEnquireClick={handleEnquireClick} />

              {/* Sticky Sidebar Form - Desktop Only */}
              <StickySidebarForm />

              {/* Main Content */}
              <main>
                <Hero onEnquireClick={handleEnquireClick} />
                <Highlights onBrochureClick={handleBrochureClick} />
                <Pricing onEnquireClick={handleEnquireClick} />
                <FloorPlans onEnquireClick={handleEnquireClick} />
                <Amenities onEnquireClick={handleEnquireClick} />
                <Gallery />
                <Location />
                <FooterContactForm />
              </main>

              {/* Popup Forms */}
              <PopupForm isOpen={showPopup} onClose={handlePopupClose} />
              <PopupForm
                isOpen={showEnquiryForm}
                onClose={() => setShowEnquiryForm(false)}
              />

              {/* Mobile Sticky Button */}
              <StickySideForm onOpen={handleEnquireClick} />

              {/* WhatsApp Button */}
              <WhatsAppButton />
            </>
          }
        />

        {/* PRIVACY POLICY PAGE */}
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/disclaimer" element={<Disclaimer />} />
        <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
        <Route path="/thank-you" element={<ThankYou />} />
      </Routes>
    </div>
  </Router>
);
}

export default App;
